'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createAccount = require('../auth/create-account');

var _createAccount2 = _interopRequireDefault(_createAccount);

var _paymentModal = require('./payment-modal');

var _paymentModal2 = _interopRequireDefault(_paymentModal);

var _pricingLevelFeature = require('./pricing-level-feature');

var _pricingLevelFeature2 = _interopRequireDefault(_pricingLevelFeature);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('div', {
    className: 'no-billing-period'
});

var _ref2 = _jsx('div', {
    className: 'no-plan-option'
});

var PricingLevel = _react2['default'].createClass({
    displayName: 'PricingLevel',


    propTypes: {
        'signupUrl': _react2['default'].PropTypes.string,
        'paymentForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'mustContactSales': _react2['default'].PropTypes.bool,
        'isUpgrade': _react2['default'].PropTypes.bool,
        'isDelinquent': _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            'expanded': false
        };
    },

    componentDidMount: function componentDidMount() {
        if (this.props.acctModalError) {
            this.launchCreateAccountModal();
        }
        if (this.props.wasSelectedBeforeLogIn) {
            this.launchPaymentModal();
        }
    },

    onLevelClick: function onLevelClick() {
        this.setState({
            'expanded': !this.state.expanded
        });
    },

    launchPaymentModal: function launchPaymentModal() {
        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('payment_modal', 'medium');
        _reactDom2['default'].render(_jsx(_paymentModal2['default'], {
            planId: this.props.planId,
            isFreeTrialEligible: this.props.isFreeTrialEligible,
            numFreeDays: this.props.numFreeDays,
            price: this.props.price,
            timePeriod: this.props.timePeriod,
            monthlyExpectedRate: this.props.monthlyExpectedRate,
            annualExpectedRate: this.props.annualExpectedRate,
            monthlyProratedRate: this.props.monthlyProratedRate,
            annualProratedRate: this.props.annualProratedRate,
            currentMonthlyRate: this.props.currentMonthlyRate,
            currentAnnualRate: this.props.currentAnnualRate,
            isTrialing: this.props.isTrialing,
            proratio: this.props.proratio,
            couponCode: this.props.couponCode,
            ccSuffix: this.props.ccSuffix,
            ccExpiration: this.props.ccExpiration,
            cardHolderName: this.props.cardHolderName ? this.props.cardHolderName : "",
            name: this.props.name,
            isApi: this.props.isApi,
            isEventbrite: this.props.isEventbrite,
            termsAccepted: this.props.currentAnnualRate > 0,
            paymentForm: this.props.paymentForm
        }, this.props.planId), attachPoint);
    },

    launchCreateAccountModal: function launchCreateAccountModal() {

        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('create_account_modal');

        var redirectUrl = 'onboarding/start';
        if (this.props.monthlyExpectedRate > 0) {
            redirectUrl = (this.props.isApi ? 'api/' : 'info/') + "pricing?plan_id=" + this.props.planId + "&period=" + this.props.timePeriod + (this.props.couponCode ? "&coupon_code=" + this.props.couponCode : "");
        }
        if (this.props.isEventbrite) {
            redirectUrl += "&is_eventbrite=true";
        }

        var googleOpenIdUrl = this.props.timePeriod == 'M' ? this.props.googleOpenIdUrlMonthly : this.props.googleOpenIdUrlAnnual;

        _reactDom2['default'].render(_jsx(_createAccount2['default'], {
            planId: this.props.planId,
            googleOpenIdUrl: googleOpenIdUrl,
            errorMsg: this.props.acctModalError,
            header: 'Let\'s get started',
            buttonText: 'Continue',
            isFromApiPricing: this.props.isApi,
            isFromPricing: !this.props.isApi,
            redirectUrl: redirectUrl,
            tabOffset: 1000,
            signupUrl: this.props.signupUrl,
            signupForm: this.props.signupForm
        }), attachPoint);
    },

    launchSalesModal: function launchSalesModal() {
        $('#contactUsButton').click();
    },

    resumeSub: function resumeSub() {
        var plan_param = this.props.isApi ? "plan_type=api" : "plan_type=ui";
        window.location.href = "/account/revertPendingCancellation?" + plan_param;
    },

    redirectToCardUpdate: function redirectToCardUpdate() {
        window.location.href = "/account/updateCard";
    },

    render: function render() {
        var isFree = this.props.monthlyExpectedRate <= 0;
        var mostPopular = this.props.mostPopular ? _jsx('img', {
            className: 'most-popular show-for-large-up',
            src: require('./most_popular.png')
        }) : '';
        var bodyClasses = (0, _classnames2['default'])({
            'm-pricing-level--body': true,
            'small-12': true,
            'columns': true,
            'expanded': this.state.expanded
        });

        var seatBadge;
        if (this.props.maxSeats && parseInt(this.props.maxSeats) > 1) {
            var seatBadgeText = '1 - ' + this.props.maxSeats + ' SENDERS';
            seatBadge = _jsx('div', {
                className: 'm-pricing-level--seat-range hide-for-medium-down'
            }, void 0, _jsx('p', {
                className: 'max-seats-badge'
            }, void 0, seatBadgeText));
        }

        var price = "0",
            period = '',
            otherPrice,
            otherPeriod,
            billingPeriod;
        if (!isFree) {
            if (this.props.timePeriod == 'M') {
                price = this.props.monthlyCouponPrice ? this.props.monthlyCouponPrice : this.props.monthlyPrice;
                period = 'per month';
            } else {
                price = this.props.annualCouponPrice ? this.props.annualCouponPrice : this.props.annualPrice;
                period = 'per month when paid annually';
            }
            billingPeriod = _jsx('div', {
                className: 'billing-period'
            }, void 0, period);
        } else {
            billingPeriod = _ref;
        }

        var oldPrice, oldPriceMobile;
        if (this.props.coupon) {
            oldPrice = _jsx('div', {
                className: 'm-pricing-level--body small-4 large-12 small-centered columns level-price'
            }, void 0, _jsx('div', {
                className: 'dollar crossed'
            }, void 0, '$'), _jsx('div', {
                className: 'price crossed'
            }, void 0, this.props.price));
            var oldPriceMobileClasses = (0, _classnames2['default'])({
                'show-for-medium-only': true,
                'small-1': true,
                'medium-3': true,
                'columns': true,
                'level-price': true,
                'l-padding-t-35': true
            });
            oldPriceMobile = _jsx('div', {
                className: oldPriceMobileClasses
            }, void 0, _jsx('span', {
                className: 'dollar crossed'
            }, void 0, '$'), _jsx('span', {
                className: 'price crossed'
            }, void 0, this.props.price));
        }

        // Get started button logic
        var getStarted;
        if (this.props.isCurrentPlan && !this.props.isDelinquent && (!this.props.isApi && this.props.UiPendingCancel || this.props.isApi && this.props.ApiPendingCancel) && this.props.isAdmin) {
            var buttonText = "Resume";
            var buttonFunc = this.resumeSub;
            getStarted = _jsx(_button2['default'], {
                buttonText: buttonText,
                onClick: buttonFunc,
                buttonHoverColor: 'cerulean'
            });
            // Special cases for delinquent subscriptions
        } else if (this.props.isDelinquent) {
                var buttonText, buttonColor, buttonHoverColor, buttonDisabled, buttonFunc;
                // Allow access to CC update only on current plan
                if (this.props.isCurrentPlan) {
                    buttonText = "Update payment info";
                    buttonFunc = this.redirectToCardUpdate;
                    buttonColor = 'ashen';
                    buttonHoverColor = 'cerulean';
                    // Disallow plan change
                } else {
                        buttonText = "Unavailable";
                        buttonFunc = function buttonFunc() {}; // noop
                        buttonColor = 'cinder-block';
                        buttonHoverColor = 'cinder-block';
                    }
                getStarted = _jsx(_button2['default'], {
                    buttonText: buttonText,
                    onClick: buttonFunc,
                    buttonColor: buttonColor,
                    buttonHoverColor: buttonHoverColor
                });
            } else if (this.props.isCurrentPlan) {
                getStarted = _jsx('div', {
                    className: 'current-plan'
                }, void 0, 'You are currently on this plan');
            } else if (this.props.isAdmin && (!this.props.isApi && !this.props.UiPendingCancel || this.props.isApi && !this.props.ApiPendingCancel)) {
                var buttonText = isFree || this.props.isApi ? 'Get Started' : 'Start Free Trial';
                var buttonFunc = this.launchCreateAccountModal;
                if (this.props.isLoggedIn) {
                    buttonText = 'Get Started';
                    buttonFunc = this.launchPaymentModal;
                }
                if (this.props.mustContactSales && this.props.isUpgrade) {
                    buttonFunc = this.launchSalesModal;
                }
                getStarted = _jsx(_button2['default'], {
                    buttonText: buttonText,
                    onClick: buttonFunc,
                    buttonHoverColor: 'cerulean'
                }); //FIXME: test
            } else {
                    getStarted = _ref2;
                }

        var freeTrial = '';
        if (this.props.isAdmin && this.props.isFreeTrialEligible && !this.props.isApi && !this.props.isCurrentPlan && !isFree) {
            freeTrial = _jsx('div', {
                className: 'm-pricing-level--num-trial-days'
            }, void 0, '' + this.props.numFreeDays + '-day free trial');
        } else {
            var freeTrialClasses = (0, _classnames2['default'])({
                'current-plan': this.props.isCurrentPlan,
                'm-pricing-level--no-free-trial': true
            });
            freeTrial = _jsx('div', {
                className: freeTrialClasses
            });
        }

        var mainFeature;
        if (this.props.mainFeature) {
            var name = this.props.mainFeature.name ? this.props.mainFeature.name : name;
            var detail = this.props.mainFeature.detail ? this.props.mainFeature.detail : null;
            var number = this.props.mainFeature.number ? this.props.mainFeature.number : null;
            mainFeature = _jsx(_pricingLevelFeature2['default'], {
                name: name,
                planName: this.props.name,
                detail: detail,
                number: number,
                isFree: isFree,
                expanded: this.state.expanded
            }, 'main-feature');
        }

        var features = this.props.features.map(function (feature, i) {
            var name = feature.name ? feature.name : name;
            var detail = feature.detail ? feature.detail : null;
            var number = feature.number ? feature.number : null;
            return _jsx(_pricingLevelFeature2['default'], {
                name: name,
                planName: this.props.name,
                detail: detail,
                number: number,
                isFree: isFree,
                expanded: this.state.expanded
            }, 'feature' + i);
        }.bind(this));

        var name = this.props.name;
        if (this.props.isEventbrite) {
            name = name.replace("Eventbrite ", "");
        }

        var levelClasses = (0, _classnames2['default'])({
            'small-5': true,
            'medium-4': !this.props.coupon,
            'medium-offset-1': true,
            'medium-3': this.props.coupon,
            'large-12': true,
            'large-offset-0': true,
            'columns': true,
            'level-title': true
        });
        var priceClasses = (0, _classnames2['default'])({
            'hide-for-large-up': true,
            'small-7': true,
            'medium-5': true,
            'medium-offset-0': this.props.coupon,
            'medium-offset-1': !this.props.coupon,
            'columns': true,
            'level-price': true
        });
        var arrowContainerClasses = (0, _classnames2['default'])({
            'arrow-container': true,
            'hide-for-large-up': true,
            'hide-for-small': true,
            'small-2': true,
            'medium-1': true,
            'columns': true
        });
        var arrowClasses = (0, _classnames2['default'])({
            'l-vertical-align': true,
            'arrow': true,
            'expanded': this.state.expanded
        });
        var pricingLevelColumnClasses = (0, _classnames2['default'])({
            'm-pricing-level': true,
            'small-12': true,
            'medium-12': true,
            'large-3': this.props.totalColumns >= 3,
            'large-4': this.props.totalColumns == 2,
            'large-6': this.props.totalColumns == 1,
            'columns': true
        });
        return _jsx('div', {
            className: pricingLevelColumnClasses
        }, void 0, _jsx('div', {
            className: 'm-pricing-level--header small-12 medium-12 columns block',
            onClick: this.onLevelClick
        }, void 0, _jsx('div', {
            className: levelClasses
        }, void 0, _jsx('div', {
            className: 'level-title l-vertical-align-wrapper'
        }, void 0, _jsx('div', {
            className: 'l-vertical-align'
        }, void 0, name ? name.toUpperCase() : ""))), seatBadge, oldPriceMobile, _jsx('div', {
            className: priceClasses
        }, void 0, _jsx('div', {
            className: 'level-title l-vertical-align-wrapper'
        }, void 0, _jsx('div', {
            className: 'l-vertical-align'
        }, void 0, _jsx('span', {
            className: 'dollar'
        }, void 0, '$'), _jsx('span', {
            className: 'price'
        }, void 0, price, _jsx('span', {
            className: 'billing-period'
        }, void 0, period))))), _jsx('div', {
            className: arrowContainerClasses
        }, void 0, _jsx('div', {
            className: 'level-title l-vertical-align-wrapper'
        }, void 0, _jsx('div', {
            className: arrowClasses
        }, void 0, ' '))), mostPopular), _jsx('div', {
            className: bodyClasses
        }, void 0, _jsx('div', {
            className: 'first-section block'
        }, void 0, oldPrice, _jsx('div', {
            className: 'm-pricing-level--body small-3 large-12 small-centered columns block'
        }, void 0, _jsx('div', {
            className: 'dollar'
        }, void 0, '$'), _jsx('div', {
            className: 'price'
        }, void 0, price), billingPeriod), _jsx('div', {
            className: 'block'
        }, void 0, getStarted, freeTrial), mainFeature)), features);
    }
});

module.exports = PricingLevel;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/pricing-level.jsx
 ** module id = 781
 ** module chunks = 0
 **/